import axiosInstance from "./axiosInstance";

export const login = async (email, password) => {
  try {
    const response = await axiosInstance.post("/user/login", {
      email,
      password,
    });
    return response.data;
  } catch (error) {
    const message = error.response?.data?.error || "Помилка при вході";
    throw new Error(message);
  }
};

export const register = async (email, password) => {
  try {
    const response = await axiosInstance.post("/user/register", {
      email,
      password,
    });
    return response.data;
  } catch (error) {
    const message = error.response?.data?.error || "Помилка при реєстрації";
    throw new Error(message);
  }
};

export const checkUser = async () => {
  try {
    const response = await axiosInstance.post("/api/check");
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.error || "Помилка перевірки користувача";
    throw new Error(message);
  }
};
